import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Button, Card, Col, Container, Image, Row } from "react-bootstrap";

export default class Landing extends Component {
  render() {
    return (
      <div
        style={{
          width: "100%",
          backgroundImage: "url('/image.jpg')",
          backgroundRepeat: "no-repeat",
          backgroundSize: "100%",
        }}
      >
        <Container style={{ height: "80vh" }}>
          <Container className="mt-5">
            <h1 style={{ textShadow: "1px 1px 2px white" }}>
              Demo Insurance Agency
            </h1>

            <h3 className="pt-4" style={{ textShadow: "1px 1px 2px white" }}>
              How can we help you?
            </h3>
          </Container>
          <Row style={{ marginTop: "150px" }}>
            <Col>
              <Card style={{ backgroundColor: "black" }}>
                <Card.Body style={{ color: "white", textAlign: "center" }}>
                  <Image
                    src="https://cdn-icons-png.flaticon.com/512/2237/2237686.png"
                    height="105"
                    width="139"
                    style={{
                      filter:
                        "invert(100%) sepia(100%) saturate(0%) hue-rotate(288deg) brightness(102%) contrast(102%)",
                    }}
                  />
                  <Card.Title>Life Insurance</Card.Title>
                  <Card.Text>
                    Ensuring protection from coverage selection to responsive
                    service.
                  </Card.Text>
                  <Link to="/life-insurance" style={{ textDecoration: "none" }}>
                    <Button variant="primary">Life Insurance</Button>
                  </Link>
                </Card.Body>
              </Card>
            </Col>
            <Col>
              <Card style={{ backgroundColor: "#1f698d" }}>
                <Card.Body style={{ color: "white", textAlign: "center" }}>
                  <Image
                    src="https://cdn-icons-png.flaticon.com/512/2237/2237686.png"
                    height="105"
                    width="139"
                    itemProp="thumbnailUrl"
                    style={{
                      filter:
                        "invert(100%) sepia(100%) saturate(0%) hue-rotate(288deg) brightness(102%) contrast(102%)",
                    }}
                  ></Image>
                  <Card.Title>Private Liability Insurance</Card.Title>
                  <Card.Text>
                  Ensuring protection from coverage selection to responsive service.
                  </Card.Text>
                  <Link
                    to="/private-liability-insurance"
                    style={{ textDecoration: "none" }}
                  >
                    <Button variant="primary">
                      Private Liability Insurance
                    </Button>
                  </Link>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}
